module.exports = __webpack_public_path__ + "static/img/technology-4-Support-img-1-en.7418b35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/technology-4-Support-img-1-en.jpg
// module id = QJ/O
// module chunks = 0